export default "__VITE_ASSET__j4VqRjYN__"